var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "#DEE2FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_219_15274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 97
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_219_15274)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.3893,
    cy: 47.5841,
    rx: 19.0751,
    ry: 40.1744,
    fill: "#242446"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.3557,
    cy: 22.7381,
    rx: 6.66936,
    ry: 4.53596,
    fill: "#007C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5342 94.0552C79.5342 82.1083 69.8494 72.4235 57.9026 72.4235H38.8087C26.8619 72.4235 17.1771 82.1083 17.1771 94.0552V102.644C26.1918 108.376 36.8813 111.71 48.3557 111.71C59.8301 111.71 70.5195 108.376 79.5342 102.644V94.0552Z",
    fill: "#4D60C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3131 64.1398V70.478C55.3131 74.6625 52.2293 78.0547 48.4252 78.0547H48.2861C44.482 78.0547 41.3982 74.6625 41.3982 70.478V64.1398",
    fill: "#F8D19F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3982 68.6963C43.4891 69.5999 45.7751 70.106 48.1753 70.106H48.5361C50.9363 70.106 53.2223 69.5999 55.3131 68.6963V65.8223H41.3982V68.6963Z",
    fill: "#F5BC8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.643 48.1816H30.7305C33.1213 48.1816 35.0595 46.2434 35.0595 43.8525V43.7651C35.0595 41.3742 33.1213 39.436 30.7305 39.436H30.643C28.2521 39.436 26.314 41.3742 26.314 43.7651V43.8525C26.314 46.2434 28.2521 48.1816 30.643 48.1816ZM65.9809 48.1816H66.0683C68.4592 48.1816 70.3974 46.2434 70.3974 43.8525V43.7651C70.3974 41.3742 68.4592 39.436 66.0683 39.436H65.9809C63.59 39.436 61.6518 41.3742 61.6518 43.7651V43.8525C61.6518 46.2434 63.59 48.1816 65.9809 48.1816Z",
    fill: "#F5BD8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5361 23.7142H48.1752C38.309 23.7142 30.3109 32.1326 30.3109 42.5172V48.5986C30.3109 58.9832 38.309 67.4016 48.1752 67.4016H48.5361C58.4023 67.4016 66.4004 58.9832 66.4004 48.5986V42.5172C66.4004 32.1326 58.4023 23.7142 48.5361 23.7142Z",
    fill: "#F8D19F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7092,
    cy: 46.3846,
    rx: 2.36346,
    ry: 2.36346,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8794,
    cy: 46.3846,
    rx: 2.36347,
    ry: 2.36346,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3873 61.3383H48.3093C46.1753 61.3383 44.4454 59.6084 44.4454 57.4745V57.4354H52.2512V57.4745C52.2512 59.6084 50.5213 61.3383 48.3873 61.3383Z",
    fill: "#F3B28E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0683 39.436C57.8537 42.0394 51.447 28.3926 47.3824 35.0586C45.024 38.9263 36.0159 39.7766 29.9854 39.0362L29.9854 38.2886C29.9854 28.195 38.1678 20.0126 48.2614 20.0126H48.6306C57.8816 20.0126 65.915 26.3847 67.1916 35.2196C67.4061 36.704 66.9775 38.2159 66.0813 39.4186L66.0683 39.436Z",
    fill: "#242446"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleAvatar);
export default __webpack_public_path__ + "static/media/female_avatar.9b8d3f2878f215188d13db0167614224.svg";
export { ForwardRef as ReactComponent };